import React from 'react'
import ProgressBar from './ProgressBar'
import { StatusBadge, UsageText } from './ProgressBar/styles'
import styled from 'styled-components'

// You can add additional styling if needed
const CompletedStatusBadge = styled(StatusBadge)`
  // Change color for expired status
  ${props => props.status === 'expired' && `
    background-color: white;
  `}
`

// Create a centered text container
const CenteredUsageText = styled(UsageText)`
  text-align: center;
  width: 100%;
`;


const CompletedAssessmentProgressBar = ({ sent = 0, completed = 0 }) => {
  // Set status to expired for red color
  const status = ''
  
  // Return "Expired" text
  const getStatusText = () => {
    return ""
  }
  
  return (
    <div style={{ width: '100%' }}>
      <ProgressBar
        value={completed}
        total={sent || 1} // Avoid division by zero
        status={status}
      >
        {/* <CompletedStatusBadge status={status}>
          {getStatusText()}
        </CompletedStatusBadge> */}
        <div style={{ 
          display: 'flex', 
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%'
        }}>
        <CenteredUsageText>
            {completed} taken / {sent} sent
          </CenteredUsageText>
        </div>
      </ProgressBar>
    </div>
  )
}

export default CompletedAssessmentProgressBar